

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Swal from 'sweetalert2';
import SliderModal from '../../Utils/sliderModal.js';
import GeneralUtils from '../../Utils/generalUtils.js';
import ValidateForm from '../../Utils/formValidation';
import { setPlanDetails } from '../../General/Actions';
import { FaPlus } from "react-icons/fa";
import { setCache, setSwitchAccountModalTrue, setCurrentPage, setRegisterDetails } from '../../General/Actions.js';
import moment from 'moment';
import MyAccountComponent from './MyAccountComponent';
import {IoMdClose} from 'react-icons/io';
import Network from '../../Utils/network.js';
import Constants from '../../Utils/constants.json';
import ActivateAddonRootComponent from './ActivateAddon/ActivateAddonRootComponent';

class FriendsnFamilyPartComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isFriendsAndFamilySectionVisible: false,
            addNumModalVisible: false,
            allFriendsAndFamilyDetails : {
                "allNumArray": []
            },
            addedNumbrsInSlider:[],
            existingNumbersBackup:[],
              existingNumbers: [],
              number: "",
              isPopupVisible: false,
              removeNumModalVisible: false,
              removeNumbersInSlider: [],
              replaceNumModalVisible: false,
              numberForReplaceFnF : "",
              addedNumberContent: "",
              redirectToMyAccount: false,
              fnfAddonObj: {},
              effectiveDateForFnfPo: "",
              redirectToAddSubscription: false,
              planId: "",
              newReplaceNumber: "",
              expiryDate: ""
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        if(this.props.isFnFAdded === "true") {
            this.setState({
                planId: this.props.allCurrentPlanDetails.planIdForFnF,
                effectiveDateForFnfPo: this.props.allCurrentPlanDetails.activationDateForFnF,
                expiryDate: this.props.allCurrentPlanDetails.addonExpiryDate
            },() => {
                this.fetchFnFPOInfo(this.props.allCurrentPlanDetails.planIdForFnF);
                this.fetchViewFnf();
            });
        }
        if(this.props.cache.allServiesArray){
            var allServicesArray = this.props.cache.allServiesArray;
            for(var i= 0; i < allServicesArray.length; i++){
                if(allServicesArray[i].service_id !== this.props.serviceId){
                    if(allServicesArray[i].service_name.toUpperCase() === this.props.locales.productFamilyNameForVoice.toUpperCase()){
                        var temp = {
                            "id": i,
                            "number": GeneralUtils.formatPhoneNumberToUsFormatNew(allServicesArray[i].service_id)
                        }
                    }
                    this.state.existingNumbersBackup.push(temp)
                }
            }
        }
        setTimeout(() => {
            this.setState({
                isLoading: false
            });
        }, 1000);
    }

    fetchFnFPOInfo(receivedId){
        var dataToSendForPO = {
            "id": receivedId,
            "date": this.state.effectiveDateForFnfPo
            //"date": ""
        }
      
        this.setState({isLoading: true})
        Network.executeAxios("fetchPO", "POST", dataToSendForPO, (fetchAddonsResponse) => {
            this.setState({isLoading: false})
            var maxFnFEntriesAllowed = 0;
            var fnfModificationFee = 0;
            var fnfAdditionFee = 0;
            var noOfFreeFFmodification = 0;
          try{
            var fnfNameObj = fetchAddonsResponse.ratingParameters[0].fnfName
            maxFnFEntriesAllowed = parseInt(fnfNameObj.maxNumFFEntriesPerGroup)
            fnfModificationFee = fnfNameObj.ffListModificationFee
            fnfAdditionFee = fnfNameObj.ffAdditionFee
            noOfFreeFFmodification = fnfNameObj.noOfFreeFFmodification
          } catch(err){
            console.log("error>>>>",err)
          }

          var addonName = "NA";
          if(fetchAddonsResponse && fetchAddonsResponse.marketingDescription){
            addonName = fetchAddonsResponse.marketingDescription;
          }

          var addonDesc = "NA";
          if(fetchAddonsResponse && fetchAddonsResponse.description){
            addonDesc = fetchAddonsResponse.description;
          }

            var productPrice = "0"
            try {
                if (fetchAddonsResponse.productOfferingPrice[0]) {
                    for (var i = 0; i < fetchAddonsResponse.productOfferingPrice.length; i++) {
                        if (fetchAddonsResponse.productOfferingPrice[i].priceCategory.id === "0") {
                            productPrice = fetchAddonsResponse.productOfferingPrice[i].price;
                        }
                    }
                }
        } catch (err) {
            productPrice = "0"
        }

        var addonPrice = GeneralUtils.formatNumberToStandardForm(productPrice,this.props.configurationValues)
        var Price = addonPrice.split(".");
        var packageAmount = 0
        var packageAmount_sup = 0
        packageAmount = Price[0]
        if (Price.length > 1) {
            packageAmount_sup = Price[1];
        } else {
            packageAmount_sup = "00"
        }

          var temp = {
              "addonName": addonName,
              "addonDesc": addonDesc,
              "packageAmount": packageAmount,
              "packageAmount_sup": packageAmount_sup,
              "maxFnFEntriesAllowed": maxFnFEntriesAllowed,
              "noOfFreeFFmodification": noOfFreeFFmodification,
              "fnfModificationFee": fnfModificationFee,
              "fnfAdditionFee": fnfAdditionFee
          }
          this.setState({fnfAddonObj: temp, isLoading: false})
        })
    }

    fetchViewFnf(){
        this.state.allFriendsAndFamilyDetails.allNumArray = [];
        this.setState({isLoading: true})
        Network.executeAxios("viewFnF", "POST", {"serviceId": this.props.serviceId} , (fnfViewResponse) => {
            this.setState({isLoading: false})
            if(fnfViewResponse && fnfViewResponse.resultParam && fnfViewResponse.resultParam.resultCode){
                var resultCode = fnfViewResponse.resultParam.resultCode;
                //var resultDesc = fnfViewResponse.resultParam.resultDescription
                if(resultCode === "3171"){
                    if(fnfViewResponse && fnfViewResponse.responseParam && fnfViewResponse.responseParam.offers){
                        console.log("fnfViewResponse.responseParam.offers",fnfViewResponse.responseParam.offers)
                        var offerArray = fnfViewResponse.responseParam.offers;
                        for(var k=0; k<offerArray.length; k++){
                            //planId = offerArray[k].id;
                            //if(planId === this.state.planId){
                                if(offerArray[k].groups){
                                    var groupsArr = offerArray[k].groups;
                                    for(var m=0; m < groupsArr.length; m++){
                                        if(groupsArr[m].fnfMembers){
                                            var fnfNumbers = groupsArr[m].fnfMembers
                                            for(var n=0; n<fnfNumbers.length; n++){
                                                let temp = {
                                                    "phoneNum": GeneralUtils.formatPhoneNumberToUsFormatNew(fnfNumbers[n].id),
                                                    "addedDate": "",
                                                    "planId": this.state.planId
                                                }
                                                this.state.allFriendsAndFamilyDetails.allNumArray.push(temp)
                                            }
                                        }
                                    }
                                }
                            //}
                        }
                    } 
                } 
                // else {
                //     Swal.fire(resultDesc, "","");
                // }
             } else {
                Swal.fire(this.props.locales.internalErrorTitleInSwal, "","");
             }
          
             console.log("allNums>>>>",this.state.allFriendsAndFamilyDetails)
            this.setState({"dummy":"dummy"})
        })
    }

    render() {
        if (this.state.redirectToMyAccount) {
            return (
                <MyAccountComponent feature={this.state.feature} />
            )
        }
        if (this.state.redirectToAddSubscription) {
            return (
                <ActivateAddonRootComponent />
            )
        }
            return (
                <div>
                    {!this.state.isLoading ? this.componentContent() : <LoadingAnimation isVisible={true} />}
                </div>
            );
        
    }

    tabLinkClicked(type){
        if(type === "manageService"){
            this.setState({feature: "addAddon"})
        }
        this.setState({redirectToMyAccount:true})
    }

    fnfLnksClicked(type,receivedNum){
        var clonedArray = JSON.parse(JSON.stringify(this.state.existingNumbersBackup))
        this.state.existingNumbers = clonedArray;
        this.state.existingNumbers = this.state.existingNumbers.filter(ar => !this.state.allFriendsAndFamilyDetails.allNumArray.find(rm => (rm.phoneNum === ar.number) ))
        if(type === "add"){
            this.setState({addNumModalVisible: true, addedNumbrsInSlider: []})
        } else if(type === "remove"){
            this.setState({removeNumModalVisible: true, removeNumbersInSlider: []})
        } else if(type === "replace"){
            this.setState({numberForReplaceFnF:receivedNum, addedNumbrsInSlider: [], replaceNumModalVisible: true})
        }  else if(type === "addAddon"){
            Network.executeAxios("fetchCcmConfig", "POST", {"keyword": "RedemptionPoint"}, (ccmConfigResponse) => {
                this.props.setCache("ccmConfigResponse", ccmConfigResponse);
                this.props.setRegisterDetails("generalResponse.type","addFnFAddon")
                window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                this.props.setRegisterDetails("services", this.props.allCurrentPlanDetails.currentService);
                this.props.setRegisterDetails("givenAddress", this.props.allCurrentPlanDetails.serviceAddress);
                this.props.setRegisterDetails("activeAddons", this.props.allCurrentPlanDetails.allAddonArray);
                this.props.setCurrentPage("pageName", "fnfAddons");
                this.setState({ redirectToAddSubscription: true })
                this.props.setRegisterDetails("customize.addons", []);
            
                // var dataToSend = {
                //     "serviceId": this.props.serviceId,
                //     "actionType": "add_on_add"
                // }
                // this.eligibilityAndFeasibilityCheck(dataToSend,"addAddon")
                });
        }
    }

    eligibilityAndFeasibilityCheck(dataToSend,type) {
        this.setState({ isLoading: true })
        Network.executeAxios("eligibilityValidation", "POST", dataToSend, (validationResponse) => {
            if(validationResponse && validationResponse.BillingSystem && validationResponse.BillingSystem.response
                && validationResponse.BillingSystem.response.optionlist[0] && validationResponse.BillingSystem.response.optionlist[0].response_code){
                    var resultCode = validationResponse.BillingSystem.response.optionlist[0].response_code;
                    var resultDesc = validationResponse.BillingSystem.response.optionlist[0].response_description   
                    if(resultCode === "0"){
                          var isContinue = true;  
                            if (isContinue) {
                                window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                                this.props.setRegisterDetails("services", this.props.allCurrentPlanDetails.currentService);
                                this.props.setRegisterDetails("givenAddress", this.props.allCurrentPlanDetails.serviceAddress);
                               if (type === "addAddon"){
                                    this.setState({ isLoading: false })
                                    this.props.setRegisterDetails("activeAddons", this.props.allCurrentPlanDetails.allAddonArray);
                                    this.props.setCurrentPage("pageName", "fnfAddons");
                                    this.setState({ redirectToAddSubscription: true })
                                    this.props.setRegisterDetails("customize.addons", []);
                                }
                                
                            } else {
                                this.setState({ isLoading: false })
                                Swal.fire(this.props.locales.LoginPageUnableToProcessSwal,"", "");  
                            }
                
                        //})
                    } else {
                        this.setState({ isLoading: false })
                        Swal.fire(resultDesc, "", ""); 
                         
                    }
            } else {
                this.setState({ isLoading: false })
                Swal.fire(this.props.locales.LoginPageUnableToProcessSwal, "", "");
            } 
        })
    }


    populateList(){
        const allServices = this.state.allFriendsAndFamilyDetails.allNumArray.map((item, key) => {
            return(
                <div className="col-md-6" key={key}>
                    <div className="p-3 mt-4 d-flex align-items-center justify-content-between" style={{backgroundColor:'#FFFFFF',height:80,border: '1px solid #EAEDF0',borderRadius:6}}>
                            <div className="d-flex flex-column">
                                <div style={{color: '#33495F',fontWeight:600,fontSize:16}}>{item.phoneNum}</div>
                                <div style={{color: '#33495F',fontWeight:400,fontSize:14, display: 'none'}}>Added on <span style={{fontWeight:600}}>{item.addedDate}</span></div>
                            </div>
                            { this.props.locales.enableFnFAddReplaceRemove === "true" ?
                            <div className="" style={{color: '#EE3124',fontSize:12,fontWeight:500,cursor:'pointer'}} onClick={() => { this.fnfLnksClicked("replace",item.phoneNum) }}>
                                Replace
                            </div>
                            : null }
                    </div>
                </div>
            )
        })
        return (allServices)
    }

    
    addNumModalHandler = (dataObject) => {
        if (dataObject.type  === "cancel") {
            document.body.classList.remove('modal-open');
            this.setState({ addNumModalVisible: false })
        } else if (dataObject.type  === "submit") {
            var totalFnfAddonsForAddition = this.state.addedNumbrsInSlider.length
            var existingFnfAddons = this.state.allFriendsAndFamilyDetails.allNumArray.length
            if((parseInt(totalFnfAddonsForAddition))+(parseInt(existingFnfAddons)) > parseInt(this.state.fnfAddonObj.maxFnFEntriesAllowed)){
                this.setState({addNumModalVisible:false})
                Swal.fire(this.props.locales.maximumNumExceedsSwalMsgFnF,"","")
            } else {
            var canContinue = [];
            for(let k=0; k< this.state.addedNumbrsInSlider.length; k++)
            {
                var fnfNumFormatted =  this.state.addedNumbrsInSlider[k].phoneNum.replace(/\D/g, "")
                var dataToSend = {
                    "serviceId": this.props.serviceId,
                    "fnfNum": fnfNumFormatted,
                    "planId": this.state.planId
                }
                this.setState({isLoading: true})
                Network.executeAxios("addFnF", "POST", dataToSend, (fnfAddResponse) => {
                    this.setState({addNumModalVisible:false})
                    var resultDesc = "NA";
                    this.setState({isLoading: false})
                    if(fnfAddResponse &&  fnfAddResponse.resultCode){
                        if(fnfAddResponse.resultCode === "0") {
                            canContinue.push("true");
                        } else {
                            if(fnfAddResponse && fnfAddResponse.resultParam && fnfAddResponse.resultParam.resultDescription){
                                resultDesc = fnfAddResponse.resultParam.resultDescription;
                            }
                            canContinue.push("false");
                        }
                    } else {
                        canContinue.push("false");
                        Swal.fire(this.props.locales.internalErrorTitleInSwal, "","");
                    }

                    if(k === this.state.addedNumbrsInSlider.length-1) {
                        var numOfTrue = canContinue.filter(function(x){ return x === "true"; }).length;
                        var numOfFalse = canContinue.filter(function(x){ return x === "false"; }).length;
                        var addedNumbersCount = 0
                        if(parseInt(numOfTrue) == 0){
                            this.setState({addNumModalVisible:false})
                            Swal.fire(resultDesc);
                        } else if(parseInt(numOfTrue) <= this.state.addedNumbrsInSlider.length){
                            addedNumbersCount = numOfTrue
                        }

                        if(parseInt(numOfFalse) > 0){
                            Swal.fire({
                                title: resultDesc,
                                text: '',
                                type: '',
                                showCancelButton: false,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    if(parseInt(addedNumbersCount) > 0){
                                        this.fetchViewFnf();
                                        var addedContentForPopup = addedNumbersCount + " Phone Number(s) added to F&F"
                                        this.setState({addedNumberContent: addedContentForPopup})
                                        this.state.addedNumbrsInSlider = []
                                        this.state.number = ""
                                        this.setState({addNumModalVisible:false,isPopupVisible:true})
                                        setTimeout(() => {
                                         this.setState({ isPopupVisible: false });
                                     }, 6000);
                                    }
                                }
                            });
                        } else if(parseInt(addedNumbersCount) > 0){
                            this.fetchViewFnf();
                            var addedContentForPopup = addedNumbersCount + " Phone Number(s) added to F&F"
                            this.setState({addedNumberContent: addedContentForPopup})
                            this.state.addedNumbrsInSlider = []
                            this.state.number = ""
                            this.setState({addNumModalVisible:false,isPopupVisible:true})
                            setTimeout(() => {
                             this.setState({ isPopupVisible: false });
                         }, 6000);
                        }
                    }
                })
            }
        }
        }
    }

    replaceNumModalHandler = (dataObject) => {
        if (dataObject.type  === "cancel") {
            document.body.classList.remove('modal-open');
            this.setState({ replaceNumModalVisible: false })
        } else if (dataObject.type  === "submit") {
        if (ValidateForm.inputFieldMandatoryCheck("replacePhoneNumPart", this.props.locales)) {
            if (ValidateForm.inputFieldValueCompositionCheck("replacePhoneNumPart", this.props.locales)) {
            this.setState({isLoading: true})  
            var existingFnfNumFormatted =  this.state.numberForReplaceFnF.replace(/\D/g, "")
            var newFnfNumFormatted = this.state.newReplaceNumber.replace(/\D/g, "")
            var dataToSend = {
                "serviceId": this.props.serviceId,
                "existingFnfNum": existingFnfNumFormatted,
                "newFnfNum": newFnfNumFormatted,
                "planId": this.state.planId
            }
            Network.executeAxios("modifyFnF", "POST", dataToSend, (fnfModifyResponse) => {
                this.setState({isLoading: false})
                if(fnfModifyResponse && fnfModifyResponse.resultCode){
                    var resultDescription = fnfModifyResponse.resultParam.resultDescription
                    if(fnfModifyResponse.resultCode === "0") {
                        this.fetchViewFnf();
                        var addedContentForPopup = this.state.numberForReplaceFnF+" Successfully replaced with "+this.state.newReplaceNumber
                        this.setState({addedNumberContent: addedContentForPopup})
                        this.state.addedNumbrsInSlider = []
                        this.state.numberForReplaceFnF = ""
                        this.setState({replaceNumModalVisible:false,isPopupVisible:true})
                        setTimeout(() => {
                         this.setState({ isPopupVisible: false });
                     }, 6000);
                    } else {
                        Swal.fire(resultDescription, "","");
                    }
                } else {
                    console.log("errrr")
                    Swal.fire(this.props.locales.internalErrorTitleInSwal, "","");
                }
            })
        }
    }
}
}

    removeNumModalHandler = (dataObject) => {
        if (dataObject.type  === "cancel") {
            document.body.classList.remove('modal-open');
            this.setState({ removeNumModalVisible: false })
        } else if (dataObject.type  === "submit") {
            Swal.fire({
                title: 'You are removing '+this.state.removeNumbersInSlider.length+' phone number(s) from F&F.',
                text: "",
                type: '',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                reverseButtons: true
                }).then((result) => {
                    if (result.value) { 
                        var canContinue = []
                        this.setState({isLoading: true})
                        for(let k = 0; k < this.state.removeNumbersInSlider.length; k++){
                            var fnfNumFormatted =  this.state.removeNumbersInSlider[k].phoneNum.replace(/\D/g, "")
                            var dataToSend = {
                                "serviceId": this.props.serviceId,
                                "fnfNum": fnfNumFormatted,
                                "planId": this.state.removeNumbersInSlider[k].planId
                            }
                            Network.executeAxios("removeFnF", "POST", dataToSend, (fnfRemoveResponse) => {
                                if(fnfRemoveResponse &&  fnfRemoveResponse.resultCode){
                                    if(fnfRemoveResponse.resultCode === "0") {
                                        canContinue.push("true");
                                    } else {
                                        canContinue.push("false");
                                    }
                                } else {
                                    canContinue.push("false");
                                    Swal.fire(this.props.locales.internalErrorTitleInSwal, "","");
                                }

                                if(k === this.state.removeNumbersInSlider.length -1) {
                                    var numOfTrue = canContinue.filter(function(x){ return x === "true"; }).length;
                                    var addedNumbersCount = 0
                                    if(parseInt(numOfTrue) == 0){
                                        this.setState({removeNumModalVisible:false, isLoading: false})
                                        Swal.fire(this.props.locales.internalErrorTitleInSwal, "","");
                                    } else {
                                        addedNumbersCount = numOfTrue
                                    }
                    
                                    if(parseInt(addedNumbersCount) > 0){
                                        this.fetchViewFnf();
                                        var addedContentForPopup = addedNumbersCount+" Phone Number(s) removed from F&F"
                                        this.setState({addedNumberContent: addedContentForPopup})
                                        this.state.removeNumbersInSlider = []
                                        this.state.number = ""
                                        this.setState({removeNumModalVisible:false,isPopupVisible:true})
                                        setTimeout(() => {
                                             this.setState({ isPopupVisible: false });
                                        }, 6000);
                                     }
                                }
                            })
                        }
                    }
                });
        }
    }

    handleInputValueChange(name, event, type) {
        this.state[name]=event;
        this.setState({"dummy":"dummy"})
    };

    handleContactNumberOnBlur = (value) => {
        var formatedDate = GeneralUtils.formatPhoneNumberToUsFormatNew(this.state[value]);
        this.state[value] = formatedDate;
        this.setState({ dummy: "dummy" });
    }

    addButtonClicked = (type,selectedItem) => {
        if(type === "add"){
            if (ValidateForm.inputFieldMandatoryCheck("phoneMumPart", this.props.locales)) {
                if (ValidateForm.inputFieldValueCompositionCheck("phoneMumPart", this.props.locales)) {
                    if(this.state.addedNumbrsInSlider.some(num => num.phoneNum == this.state.number)) {
                        Swal.fire(this.props.locales.numAlreadyAddedSwalMsgInFnf, "", "");
                    } else if(this.state.allFriendsAndFamilyDetails.allNumArray.some(num => num.phoneNum == this.state.number)) {
                        Swal.fire(this.props.locales.numAlreadyExistsSwalMsgInFnF, "", "");
                    } else if(this.state.number === this.props.serviceId){
                        Swal.fire(this.props.locales.ownServiceErrMsgInFnF)
                    } else {
                        this.state.addedNumbrsInSlider.push(
                            {
                            "phoneNum": this.state.number,
                            "addedDate": moment(new Date()).format("MM/DD/YYYY")
                            }
                        )
                        this.setState({number: ""})
                    }    
                }
            }
        } else if(type === "select"){
            if(this.state.allFriendsAndFamilyDetails.allNumArray.some(num => num.phoneNum == this.state.number)) {
                Swal.fire(this.props.locales.numAlreadyExistsSwalMsgInFnF, "", "");
            } else {
                this.state.addedNumbrsInSlider.push(
                    {
                    "phoneNum": selectedItem.number,
                    "addedDate": moment(new Date()).format("MM/DD/YYYY")
                    }
                )
                this.state.existingNumbers = this.state.existingNumbers.filter(ar => !this.state.addedNumbrsInSlider.find(rm => (rm.phoneNum === ar.number) ))
                this.setState({"dummy":"dummy"})
            }    
        }
       
    }

    removeButtonClickedInSlider =(receivedNum) => {
        this.state.addedNumbrsInSlider.filter(x => x.phoneNum === receivedNum).forEach(x => this.state.addedNumbrsInSlider.splice(this.state.addedNumbrsInSlider.indexOf(x), 1));
        if(this.state.existingNumbersBackup.some(numberArray => numberArray.number === receivedNum)){
            this.state.existingNumbers.push({
                "id": "",
                "number": receivedNum
            })
        }
        this.setState({"dummy":"dummy"})
    }

    removeFnFLinkClickedInSlider = (receivedNum,planId,type) => {
        if(type === "select"){
            this.state.removeNumbersInSlider.push(
                {
                "phoneNum": receivedNum,
                "planId": planId
                }
            )
        } else if (type === "unselect"){
            this.state.removeNumbersInSlider.filter(x => x.phoneNum === receivedNum).forEach(x => this.state.removeNumbersInSlider.splice(this.state.addedNumbrsInSlider.indexOf(x), 1));
        }
        this.setState({"dummy":"dummy"})
    }

    closePopup(){
        this.setState({isPopupVisible: false})
    }

    componentContent(){
        var widthFromVar = 0;
        var used = 0;
       
        if(this.props.isFnFAdded === "true"){
            used =  Math.round(this.state.allFriendsAndFamilyDetails.allNumArray.length)
            widthFromVar = Math.round((parseFloat(used) / parseFloat(this.state.fnfAddonObj.maxFnFEntriesAllowed)) * 100) + "%"
        }
        return(
            <div id="myAccountInternetTopDivContainer" className="animated fadeIn px-sm-5 px-0">

            {this.state.isPopupVisible ?
                <div className={this.state.isPopupVisible ?"col-12 animated fadeIn row popupFoSuccess" : "col-12 animated fadeOut row popupFoSuccess" } style={{zIndex:10}}>
                   <div className="col-12 d-flex justify-content-between align-items-center">
                   {this.state.addedNumberContent}
                        <div> <IoMdClose style={{cursor: 'pointer'}} onClick={() => this.closePopup()} /></div>
                   </div>
                </div>
            : null } 

            <div className="d-flex justify-content-between px-4 mt-5" style={{ height: 65, position: 'relative' }}>
                <div className="text-left pt-md-0 pt-3 pl-sm-3 pl-0">
                    <div className="" style={{ color: '#231F20', fontSize: 24, fontWeight: 500 }}>{this.props.locales.servicesTextForTabLinkManageService}</div>
                    <div className="d-flex mb-0" style={{ color: '#231F20' }}>
                        <div className="" style={{ cursor: 'pointer', fontSize: 18 }} onClick={() => this.tabLinkClicked('myAccount')}>{this.props.locales.myAccountTextInTabLinkManageService} &nbsp;&nbsp;></div>
                        <div className="ml-3" style={{ cursor: 'pointer', fontSize: 18, fontWeight: 500 }}  onClick={() => this.tabLinkClicked('manageService')}>{this.props.locales.FnFTabLinkHeading}</div>
                    </div>
                </div>
            </div>
        
            {this.props.isFnFAdded === "true" ?
            <div className="" style={{width:'95%', margin:'auto',padding:'25px 0px'}}>
                <div className="col-md-12 mb-4">
                     <div className="p-3 mt-2 d-flex align-items-center justify-content-between" style={{backgroundColor:'#FFFFFF',minHeight:115,border: '1px solid #EAEDF0',borderRadius:6}}>
                            <div className="d-flex flex-column">
                                <div style={{color: '#231F20',fontWeight:600,fontSize:18}}>{this.state.fnfAddonObj.addonName}</div>
                                <div style={{color: '#58595B',fontWeight:400,fontSize:14}} className="pt-2">{this.props.locales.fnfAddonDescriptionSecHeading}: <span style={{fontWeight:600}}>{this.state.fnfAddonObj.addonDesc}</span></div>
                                <div style={{color: '#58595B',fontWeight:400,fontSize:14}} className="pt-2">Expiry Date: <span style={{fontWeight:600}}>{this.state.expiryDate}</span></div>
                            </div>
                            <div className="d-flex flex-column" style={{width: '30%'}}>
                                <span style={{ color: '#231F20' }} className="d-flex ml-auto">
                                    <span>{Constants.dollarSign}</span><span style={{ lineHeight: '32px', fontSize: 28 }}>{this.state.fnfAddonObj.packageAmount}</span><span>{this.state.fnfAddonObj.packageAmount_sup}{this.props.locales.perMonthTextForAmount}</span>
                                </span>
                               
                                    <div className="pt-2 d-none d-sm-block">
                                        <div className="d-flex justify-content-between" style={{ fontSize: 12, color: '#0049A5' }}>
                                            <div>{this.props.locales.usageSecHeadingInAllAddons}</div>
                                            <div style={{ fontWeight: 500 }}>{this.state.allFriendsAndFamilyDetails.allNumArray.length}/{this.state.fnfAddonObj.maxFnFEntriesAllowed} FnF Added</div>
                                        </div>
                                        <div className="progress my-1" style={{ height: 10 }}>
                                            <div className="progress-bar" role="progressbar" style={{ width: widthFromVar, backgroundColor: '#0049A5' }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"> </div>
                                        </div>
                                        <div style={{ fontSize: 10, color: '#0049A5', fontWeight: 500 }}>{widthFromVar} used</div>
                                    </div>
                            </div>
                    </div>
                </div>
            <div className="col-md-12">
                <div style={{borderBottom:'1px solid #D6D6D6'}} className="d-flex justify-content-between align-items-center">
                    <div className="" style={{color: '#58595B', fontSize:18, fontWeight:600}}>{this.props.locales.allFnFSectionHeading}</div>
                    { this.state.allFriendsAndFamilyDetails.allNumArray.length > 0 && this.props.locales.enableFnFAddReplaceRemove === "true" ?
                        <div style={{color: '#EE3124',fontSize:12,fontWeight:500,cursor:'pointer'}} onClick={() => { this.fnfLnksClicked("remove") }}>{this.props.locales.removeFnFSectionHeading}</div>
                    : null }
                </div>
            </div>
            <div className="col-md-12 row p-0 m-0 mb-5">
            {this.populateList()}
            { this.props.locales.enableFnFAddReplaceRemove === "true" ?
            <div className="col-md-6" >
                <div className="mt-4" style={{ borderRadius: 6, backgroundColor: 'rgba(255,255,255,0)', border: '1px solid #A3B4BC' }}>
                    <div className="d-flex justify-content-center" onClick={() => { this.fnfLnksClicked("add") }} style={{ cursor: 'pointer'}}>
                        <div className="addressDetailsDiv p-3 d-flex flex-row justify-content-center align-items-center" style={{ textAlign: 'center' }}>
                            <div style={{ backgroundColor: 'rgba(179,179,179,0.3)', height: 52, width: 52, borderRadius: '50%', paddingTop: 13 }}><FaPlus size="15" color='#231F20' className="plusIcon" /></div>
                            <div style={{ color: '#58595B', fontSize: 14, paddingLeft: 20,fontWeight:600 }}>{this.props.locales.addFnFSectionHeading}</div>
                        </div>
                    </div>
                </div>
            </div>
            : null }
            </div>
            
            </div>
            : 
    
            <div className="" style={{width:'95%', margin:'auto',padding:'10px 0px'}}>
                <div className="col-md-12 mb-4">
                    <div className="mt-4 py-2" style={{ borderRadius: 6, backgroundColor: 'rgba(255,255,255,0)', border: '1px solid #A3B4BC' }}>
                    <div className="d-flex justify-content-center" onClick={() => { this.fnfLnksClicked("addAddon") }} style={{ cursor: 'pointer'}}>
                        <div className="addressDetailsDiv p-2 d-flex flex-row justify-content-center align-items-center" style={{ textAlign: 'center' }}>
                            <div style={{ backgroundColor: 'rgba(179,179,179,0.3)', height: 52, width: 52, borderRadius: '50%', paddingTop: 13 }}><FaPlus size="15" color='#231F20' className="plusIcon" /></div>
                            <div style={{ color: '#58595B', fontSize: 14, paddingLeft: 20,fontWeight:600 }}>ADD F&F Addon</div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            }

            {/* add F&F */}
            <SliderModal
                    isVisible={this.state.addNumModalVisible}
                    uniqueModalReferenceId="addNum"
                    mainHeading={this.props.locales.addFnFSliderMainHeading}
                    isResetButtonVisible={false}
                    leftPartFlexValue={2}
                    rightPartFlexValue={1}
                    isSubmitButtonVisible={true}
                    submitButtonText = "Confirm"
                    isValidationRequired = {false}
                    callback={this.addNumModalHandler}
                    isSubmitButtonDisabled={this.state.addedNumbrsInSlider.length>0 ? false : true}
                >
                     <div className="col-md-12">
                        <div className="col-md-12 px-2">
                            <div className="col-md-12 pt-3 p-0" id="phoneMumPart">
                                <div className="form-group col-md-12 p-0 mb-1">
                                    <label className="formGroup_label">{this.props.locales.enterPhnNumLabelFnF}</label>
                                    <div className="input-group">
                                        <input type="text" className="form-control formGroup_value mandatoryFieldWithoutStyle input_data typeNumber"
                                            name="number" autoComplete="off" maxLength="11" value={this.state.number} style={{border: '1px solid #EAEDF0',borderRadius:4}}
                                            onChange={(event) => {
                                                this.handleInputValueChange("number", event.target.value)
                                            }}
                                        />
                                        <div className="input-group-append">
                                            {this.state.number.length >= 1 ?
                                                <div className="input-group-text" style={{color: '#0285CA',cursor:'pointer',fontSize:12,fontWeight: 500, backgroundColor: '#ffffff', borderLeft: 0 }} onClick={() => this.addButtonClicked("add")}>Add</div>
                                            : null }
                                         
                                        </div>
                                    </div>
                                    <div className="errorDesc"></div>
                                </div>
                            </div>
                            {parseFloat(this.state.fnfAddonObj.fnfAdditionFee) > 0 ?
                                <div className="col-md-12 p-0 pt-2" style={{ color: '#58595B', fontSize: 12}}>
                                        You can add/modify {this.state.fnfAddonObj.noOfFreeFFmodification} F&F members for free. A charge of <strong> {Constants.dollarSign}{this.state.fnfAddonObj.fnfAdditionFee}</strong> will be applicable from next.
                                </div>
                            : null }
                        {this.state.addedNumbrsInSlider.map((item, key) => {
                                return (
                                    <div className="col-md-12 row p-0 mt-3 mx-auto px-3 justify-content-between align-items-center" style={{height:60,border: '1px solid rgba(179,179,179,0.5)',borderRadius:6,backgroundColor:'#FFFFFF'}}>
                                        <div>{item.phoneNum}</div>
                                        <div style={{color: '#EE3124',fontSize:12,fontWeight:500, cursor:'pointer'}} onClick={() => this.removeButtonClickedInSlider(item.phoneNum)}>Remove</div>
                                    </div>
                                )
                            })
                        }
                        </div>
                    </div>
                </SliderModal>

                {/* remove F&F */}
                <SliderModal
                    isVisible={this.state.removeNumModalVisible}
                    uniqueModalReferenceId="addNum"
                    mainHeading={this.props.locales.removeFnFSliderMainHeading}
                    isResetButtonVisible={false}
                    leftPartFlexValue={2}
                    rightPartFlexValue={1}
                    contentPartBackgroundColor="#F5F8FB"
                    isSubmitButtonVisible={true}
                    isValidationRequired = {false}
                    callback={this.removeNumModalHandler}
                    isSubmitButtonDisabled={this.state.removeNumbersInSlider.length>0 ? false : true}
                >
                     <div className="col-md-12">
                        <div className="col-md-12 px-2">
                            <div className="col-md-12 pt-3 p-0" id="phoneMumPart">
                                <div className="form-group col-md-12 p-0 mb-1">
                                    <label className="formGroup_label">Search Phone Number</label>
                                    <div className="d-flex">
                                        <input type="text" className="form-control formGroup_value mandatoryFieldWithoutStyle input_data typeNumber"
                                            name="number"  maxLength="11" autoComplete="off" value={this.state.number} style={{border: '1px solid #EAEDF0',borderRadius:4}}
                                            onChange={(event) => {
                                                this.handleInputValueChange("number", event.target.value)
                                                // this.handleContactNumberOnBlur("number");
                                            }}
                                        />
                                        {/* <div style={{background:'transparent', color: '#0049A5',textDecoration:'underline',border:0, cursor:'pointer'}} className="align-items-center d-flex pl-1" >Add</div> */}
                                    </div>

                                    <div className="errorDesc"></div>
                                </div>
                            </div>
                          
                        {this.state.allFriendsAndFamilyDetails.allNumArray
                                .filter(item => {
                                    if (!this.state.number) return true;
                                    if (item.phoneNum.includes(this.state.number)) {
                                        return true;
                                    }
                                    return false;
                                })
                                .map((item, key) => {
                                    var isSelected = false;
                                    for (var l = 0; l < this.state.removeNumbersInSlider.length; l++) {
                                        if (item["phoneNum"] === this.state.removeNumbersInSlider[l].phoneNum) {
                                            isSelected = true
                                        }
                                    }
                            
                                    if(isSelected){
                                        return(
                                         <div className="col-md-12 row p-0 mt-3 mx-auto px-3 justify-content-between align-items-center" style={{height:60,border: '1px solid rgba(179,179,179,0.5)',borderRadius:4,backgroundColor:'rgba(227, 25, 55, 0.1)',boxSizing: 'border-box'}} >
                                            <div>{item.phoneNum}</div>
                                            <div style={{ color: '#EE3124', cursor: 'pointer', fontSize: 12, fontWeight: 500 }} onClick={() => this.removeFnFLinkClickedInSlider(item.phoneNum,item.planId,"unselect")}>Unselect</div>   
                                         </div>
                                        )
                                    } else {
                                        return(
                                            <div className="col-md-12 row p-0 mt-3 mx-auto px-3 justify-content-between align-items-center" style={{height:60,border: '1px solid rgba(179,179,179,0.5)',borderRadius:4,backgroundColor:'#FFFFFF',boxSizing: 'border-box'}} >
                                                <div>{item.phoneNum}</div>
                                                <div style={{ color: '#0285CA', cursor: 'pointer', fontSize: 12, fontWeight: 500 }} onClick={() => this.removeFnFLinkClickedInSlider(item.phoneNum,item.planId,"select")}>Select</div>
                                            </div>
                                        )
                                    }
                                })
                       }

                        </div>
                    </div>
                </SliderModal>

                {/* replace F&F */}
                <SliderModal
                    isVisible={this.state.replaceNumModalVisible}
                    uniqueModalReferenceId="replaceNum"
                    mainHeading={this.props.locales.replaceFnFSliderMainHeading}
                    isResetButtonVisible={false}
                    leftPartFlexValue={2}
                    rightPartFlexValue={1}
                    contentPartBackgroundColor="#F5F8FB"
                    isSubmitButtonVisible={true}
                    submitButtonText = "Submit"
                    isValidationRequired = {false}
                    callback={this.replaceNumModalHandler}
                    isSubmitButtonDisabled={this.state.newReplaceNumber !== "" ? false : true}
                >
                     <div className="col-md-12">
                        <div className="col-md-12 px-2">
                            <div className="col-md-12 pt-3 p-0" id="replacePhoneNumPart">
                                <div className="form-group col-md-12 p-0 mb-1">
                                    <label className="formGroup_label">{this.props.locales.enterPhnNumLabelFnF}</label>
                                    <div className="d-flex">
                                        <input type="text" className="form-control formGroup_value mandatoryFieldWithoutStyle input_data typeNumber"
                                            name="newReplaceNumber" autoComplete="off"  maxLength="11" value={this.state.newReplaceNumber} style={{border: '1px solid #EAEDF0',borderRadius:4}}
                                            onChange={(event) => {
                                                this.handleInputValueChange("newReplaceNumber", event.target.value)
                                            }}
                                        />
                                    </div>
                                    <div className="errorDesc"></div>
                                </div>
                            </div>
                           {parseFloat(this.state.fnfAddonObj.fnfModificationFee) > 0 ?
                            <div className="col-md-12 p-0 pt-2" style={{ color: '#58595B', fontSize: 12}}>
                                    You can add/modify {this.state.fnfAddonObj.noOfFreeFFmodification} F&F members for free. A charge of <strong> {Constants.dollarSign}{this.state.fnfAddonObj.fnfModificationFee}</strong> will be applicable from next.
                            </div>
                            : null }
                          
                        {this.state.addedNumbrsInSlider.map((item, key) => {
                                return (
                                    <div className="col-md-12 row p-0 mt-3 mx-auto px-3 justify-content-between align-items-center" style={{height:60,border: '1px solid rgba(179,179,179,0.5)',borderRadius:6,backgroundColor:'#FFFFFF'}}>
                                        <div>{item.phoneNum}</div>
                                        <div style={{color: '#EE3124',fontSize:12,fontWeight:500, cursor:'pointer'}} onClick={() => this.removeButtonClickedInSlider(item.phoneNum)}>Remove</div>
                                    </div>
                                )
                            })
                        }
                        </div>
                    </div>
                </SliderModal>

            </div>
        )
    }

}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        planDetails: state.planDetails,
        contextParameters: state.contextParameters,
        feasibilityResposnse: state.feasibilityResposnse,
        configurationValues: state.configurationValues
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setPlanDetails: function (key, payload) {
            dispatch(setPlanDetails(key, payload));
        },
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        },
        setSwitchAccountModalTrue: function () {
            dispatch(setSwitchAccountModalTrue());
        },
        setCurrentPage: function (key, payload) {
            dispatch(setCurrentPage(key, payload));
        },
        setRegisterDetails: function (key, payload) {
            dispatch(setRegisterDetails(key, payload));
        }
    }
}

const FriendsnFamilyPartComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(FriendsnFamilyPartComponent)

export default FriendsnFamilyPartComponentContainer;
